/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_WebInputs */

const en_source_web = /** @type {(inputs: Source_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_source_web = /** @type {(inputs: Source_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Source_WebInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const source_web = /** @type {((inputs?: Source_WebInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_WebInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_source_web(inputs)
	return en_source_web(inputs)
});